import Section from "./Section";
import Heading from "./Heading";
import { check, gpt4, gpt6 } from "../assets";
import { proresumeServices, rebrandServices } from "../constants";
import TagLine from "./Tagline";

// Reusable Service Card component
const ServiceCard = ({ href, imgSrc, tagline, services }) => (
  <div className="relative z-1 mb-5 flex flex-col items-center overflow-hidden rounded-3xl p-8 neon-purple">
    <div className="mx-auto">
      <a href={href}>
        <img
          className="mx-auto w-full"
          width={800}
          alt="Service"
          height={230}
          src={imgSrc}
        />
      </a>
    </div>

    <TagLine className="mb-5 mt-2 flex justify-center text-center">
      {tagline}
    </TagLine>

    <div className="relative z-1 mx-auto">
      <ul>
        {services.map((item, index) => (
          <li
            key={index}
            className="flex items-start border-t border-n-6 py-2 lg:py-4"
          >
            <img width={24} height={24} src={check} alt="check" />
            <p className="ml-4">{item}</p>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const Services = () => {
  return (
    <Section id="partners">
      <div className="container">
        <Heading
          title="OUR PARTNERS"
          tag="Collaborating for Innovation, Delivering Excellence Together"
        />

        <div className="container relative">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            <ServiceCard
              href="https://proresumes.in"
              imgSrc={gpt4}
              tagline="Shaping opportunities, driving success."
              services={proresumeServices}
            />
            <ServiceCard
              href="https://www.rebrandsign.com"
              imgSrc={gpt6}
              tagline="Elevating brands, sparking transformation."
              services={rebrandServices}
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Services;
